<template>
  <td :style="data.style" v-html="cellData"></td>
</template>

<script>
export default {
  name: 'DisplayTableCell',
  props: {
    data: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    cellData() {
      return this.data && this.data.value ? this.data.value : this.data;
    },
  },
};
</script>
